import React, { useState, useEffect, useContext } from 'react'

import SiteAccessContext from '../../../contexts/SiteAccessContext';

import { useMsal } from '@azure/msal-react';
import { fetchDataAuthenticated } from '../../../utilities/HttpUtils';
import { usePrivileges } from '../../../hooks/usePrivileges';

import useAlert from '../../Alerts/useAlert';

import '../../DataGrid.css';
import gridLogo from "../../../Images/grid.svg";
import ILRInspectionLotRequestForm from './ILRInspectionLotRequestForm';
import * as ExcelJS from 'exceljs'

// Styling
import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

function ILRInspectionLotRequestGrid(props) {
    const _apiUrl = window.runtimeConfig.WEBSITE_BACKEND_URI;
    const [tableData, setTableData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [SelectedValue, setSelectedValue] = useState('');

    const { assignedSites } = useContext(SiteAccessContext);

    const { accounts } = useMsal();

    const username = accounts[0] && accounts[0].username;
    const { contributor } = usePrivileges();

    const { setAlert } = useAlert();

    const GroupDetails = (params) => {
        return (
            <strong>
                <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => {
                    openDetailsComponent(params.row);
                }}>Details</button>
            </strong>
        )
    }
    const ReProcessRow = (params) => {
        return (
            <strong>
                <button id='reprocess' type="button" disabled= {contributor &&  (params.row.status === 'N'|| params.row.status === 'F' || params.row.status === 'X' || params.row.status === 'H') ? false : true} className="btn btn-outline-primary btn-sm"  onClick={() => {
                    ReProcessILR(params.row);
                }}>ReProcess</button>
            </strong>
        )
    }
    const ForceReProcessRow = (params) => {
        return (
            <strong>
                <button id='forcereprocess' type="button" disabled= {contributor && (params.row.status === 'N'|| params.row.status === 'F' || params.row.status === 'X' || params.row.status === 'H') ? false : true} className="btn btn-outline-primary btn-sm" onClick={() => {
                    ForceReProcessILR(params.row);
                }}>ForceReProcess</button>
            </strong>
        )
    }

    const CancelLotRow = (params) => {
        return (
            <strong>
                <button id='cancel' type="button" disabled= {contributor && (params.row.status !== 'C' || params.row.status !== 'X') ? false : true} className="btn btn-outline-primary btn-sm" onClick={() => {
                    CancelILR(params.row);
                }}>Cancel</button>
            </strong>
        )
    }
    const UnblockLotRow = (params) => {
        return (
            <strong>
                <button id='unblock' type="button" disabled= {contributor && params.row.isBlocked  ? false : true} className="btn btn-outline-primary btn-sm"  onClick={() => {
                    UnblockILR(params.row);
                }}>Unblock</button>
            </strong>
        )
    }
    
    const ValidateIlrRow = (params) => {
        return (
            <strong>
                <button id='validate' type="button" disabled= {contributor ? false : true} className="btn btn-outline-primary btn-sm" onClick={() => {
                    ValidateIlr(params.row);
                }}>Validate</button>
            </strong>
        )
    }
    const ProcessRow = (params) => {
        return (
            <strong>
                <button id='process' type="button" disabled= {contributor && params.row.status === 'R' ? false : true} className="btn btn-outline-primary btn-sm"  onClick={() => {
                    ProcessILR(params.row);
                }}>Process</button>
            </strong>
        )
    }

    var _column = [
        {
            field: 'inspectionLot',
            headerName: 'inspection Lot',
            width: 150,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'creationDate',
            headerName: 'Creation Date',
            width: 150,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'qmSubSystem',
            headerName: 'QmSubSystem',
            width: 150,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'materialId',
            headerName: 'Material Id',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'materialIdDescription',
            headerName: 'Material Id Description',
            width: 150,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'materialGroup',
            headerName: 'Material Group',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        }
        ,
        {
            field: 'plantId',
            headerName: 'Plant Id',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'batchId',
            headerName: 'Batch Id',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'inspectionLotQuantity',
            headerName: 'Lot Qty',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'inspectionLotUnit',
            headerName: 'Lot Unit',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'packageConfiguration',
            headerName: 'Package Configuration',
            width: 150,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'siteName',
            headerName: 'Site Name',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'statusMessage',
            headerName: 'Status Message',
            width: 200,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'id_numeric',
            headerName: 'id_numeric',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'replied',
            headerName: 'Replied',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'modifiedBy',
            headerName: 'Modified By',
            width: 150,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'modifiedDate',
            headerName: 'Modified Date',
            width: 150,
            headerAlign: 'center',
            align: 'center'
        }
    ];

    // TODO: What roles should this column be visible for?
    // props.PostData.roleId != 3
    //if (contributor) {
        _column.push(
            {
                field: '-',
                headerName: 'Details',
                width: 100,
                renderCell: GroupDetails,
                disableClickEventBubbling: true,
                headerAlign: 'center',
                align: 'center'
            });
    //}

    //if (contributor) {
        _column.push({
            field: '/',
            headerName: 'ReProcess',
            width: 100,
            renderCell: ReProcessRow,
            disableClickEventBubbling: true,
            headerAlign: 'left',
            align: 'left'
        });

        _column.push({
            field: '*',
            headerName: 'Validate',
            width: 100,
            renderCell: ValidateIlrRow,
            disableClickEventBubbling: true,
            headerAlign: 'left',
            align: 'left'
        });

        _column.push({
            field: '%',
            headerName: 'Process',
            width: 100,
            renderCell: ProcessRow,
            disableClickEventBubbling: true,
            headerAlign: 'left',
            align: 'left'
        });

        _column.push({
            field: '+',
            headerName: 'ForceReProcess',
            width: 150,
            renderCell: ForceReProcessRow,
            disableClickEventBubbling: true,
            headerAlign: 'left',
            align: 'left'
        });

        _column.push({
            field: '^',
            headerName: 'Cancel',
            width: 100,
            renderCell: CancelLotRow,
            disableClickEventBubbling: true,
            headerAlign: 'left',
            align: 'left'
        });
        _column.push({
            field: '#',
            headerName: 'Unblock',
            width: 100,
            renderCell: UnblockLotRow,
            disableClickEventBubbling: true,
            headerAlign: 'left',
            align: 'left'
        });
    //}

    var columns: GridColDef[] = _column;

    const openDetailsComponent = (params) => {
        setOpen(true);
        setSelectedValue(JSON.stringify(params).toString());
    };

    const handleFormClose = (response) => {
        if (response !== null && response === true) {
            LoadILRInspectionLotList();
        }
        setOpen(false);
    };

    const ReProcessILR = async (rowData) => {
        const ReProcessILRFields = {
            inspectionLot: rowData.inspectionLot,
            modifiedBy: username,
        };

        const reprocessButton = document.getElementById('reprocess');
        reprocessButton.disabled = true;

        await fetchDataAuthenticated(_apiUrl + 'ReProcessILR', "POST", JSON.stringify(ReProcessILRFields))
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Something went wrong.');
            })
            .then(response => {
                setAlert("success", "Success", response.message);
                LoadILRInspectionLotList();
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
                console.error(error);
            });

    };
    const ForceReProcessILR = async (rowData) => {
        const ReProcessILRFields = {
            inspectionLot: rowData.inspectionLot,
            validationIgnore: true,
            isForceReprocess: true,
            modifiedBy: username,
        };

        const forcereprocessButton = document.getElementById('forcereprocess');
        forcereprocessButton.disabled = true;

        await fetchDataAuthenticated(_apiUrl + 'ForceReProcessILR', "POST", JSON.stringify(ReProcessILRFields))
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Something went wrong.');
            })
            .then(response => {
                setAlert("success", "Success", response.message);
                LoadILRInspectionLotList();
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
                console.error(error);
            });

    };

    const CancelILR = async (rowData) => {
        const CancelILRFields = {
            inspectionLot: rowData.inspectionLot,
            status: "X",
            statusMessage : "Cancelled by the user",
            modifiedBy: username,
        };

        const cancelButton = document.getElementById('cancel');
        cancelButton.disabled = true;

        await fetchDataAuthenticated(_apiUrl + 'UpdateIlrStatus', "POST", JSON.stringify(CancelILRFields))
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Something went wrong.');
            })
            .then(response => {
                setAlert("success", "Success", response.message);
                LoadILRInspectionLotList();
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
                console.error(error);
            });

    };

    const UnblockILR = async (rowData) => {
        const CancelILRFields = {
            inspectionLot: rowData.inspectionLot,
            isBlocked: false,
            statusMessage : "Unblocked by the user",
            modifiedBy: username,
        };

        const unblockButton = document.getElementById('unblock');
        unblockButton.disabled = true;

        await fetchDataAuthenticated(_apiUrl + 'UnblockIlr', "POST", JSON.stringify(CancelILRFields))
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Something went wrong.');
            })
            .then(response => {
                setAlert("success", "Success", response.message);
                LoadILRInspectionLotList();
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
                console.error(error);
            });

    };

    const ValidateIlr = async (rowData) => {

        const validateButton = document.getElementById('validate');
        validateButton.disabled = true;

        await fetchDataAuthenticated(_apiUrl + 'ValidateILR/' + rowData.inspectionLot + "?updateRequest=TRUE", "POST")
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Something went wrong.');
            })
            .then(response => {
                setAlert("success", "Success", response.message);
                LoadILRInspectionLotList();
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
                console.error(error);
            });

    }

    const ProcessILR = async (rowData) => {

        const processButton = document.getElementById('process');
        processButton.disabled = true;

        await fetchDataAuthenticated(_apiUrl + 'ProcessILR/' + rowData.inspectionLot, "POST")
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Something went wrong.');
            })
            .then(response => {
                setAlert("success", "Success", response.message);
                LoadILRInspectionLotList();
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
                console.error(error);
            });

    };

    const LoadILRInspectionLotList = async () => {

        let params = new URLSearchParams();

        if (assignedSites && assignedSites.length > 0) {

            assignedSites.map(si => params.append("sites", si.siteName));

            await fetchDataAuthenticated(_apiUrl + "GetInspectionRequest?" + params.toString())
                .then(response => {
                    if (response.ok && response.status === 200) {
                        return response.json();
                    }
                    else if(response.status === 204)
                    {
                        return {};
                    }
                    throw new Error('Something went wrong.');
                })
                .then((data) => {
                    setTableData(data);
                })
                .catch(error => {
                    setAlert("danger", "Error", error.message);
                    console.error(error);
                });
        }
        else {
            console.error("In LoadComponentGroupLookupList - You have no access to sites");
        }
    };

    const exportToExcel = () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('ILRs');
        worksheet.addRow(['Site','InspectionLot','CreationDate','MaterialGroup','BatchId','PlantId','Status','StatusMessage']);
        tableData.forEach(row => {
            worksheet.addRow([row.siteName,row.inspectionLot,row.creationDate,row.materialGroup,row.batchId,row.plantId,row.status,row.statusMessage])
        });
        workbook.xlsx.writeBuffer().then((buffer)=>
        {
            const blob = new Blob([buffer],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'ILRDetails.xlsx';
            a.click();
        });

    };

    useEffect(() => {
        LoadILRInspectionLotList();
    }, [assignedSites]);

    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-9 titleBar'>
                    <img src={gridLogo} alt="grid logo" className="gridLogo" />
                    ILR Inspection Lot Request
                </div>
                <div className='col-md-3'>
                    {<button type="button"  className="btn btn-outline-primary btn-primary-label" onClick={exportToExcel}>Export</button>}
                </div>
            </div>

            <Box sx={{ height: 375, width: '100%' }}>
                <DataGrid
                    rows={tableData}
                    columns={columns}
                    initialState={{
                        ...tableData.initialState,
                        pagination: { paginationModel: { pageSize: 20 } },
                      }}
                    pageSizeOptions={[20,50,100]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={(row: any) => row.inspectionLot}
                />
            </Box>

            <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="md">
                <DialogTitle className="csDialogTitle">ILR Inspection Lot</DialogTitle>
                <ILRInspectionLotRequestForm SelectedValueTochild={SelectedValue} PostData={props.PostData} CloseDialog={handleFormClose} />
            </Dialog>
        </div>
    );
}
export default ILRInspectionLotRequestGrid;